import React, { useState } from "react";
import { Button, Group, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import FiscalPeriodSelect from "./accounting/FiscalPeriodSelect";
import SubledgerReconciliationView from "./accounting/SubledgerReconciliationView";

const ReportSubledgerReconciliation = () => {
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [fiscalPeriodId, setFiscalPeriodId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      const query = {};
      if (fiscalPeriodId) query.fiscalPeriodId = fiscalPeriodId;
      const data = await api.Accounting.getSubledgerReconciliation(query);
      setReports(data?.reports || []);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Text size="xs" mb="xs">
        {t("Compare subledger balances to GL control accounts.")}
      </Text>
      <Group align="flex-end">
        <FiscalPeriodSelect
          value={fiscalPeriodId}
          onChange={setFiscalPeriodId}
          style={{ minWidth: 220 }}
        />
        <Button size="xs" onClick={load} loading={loading}>
          {t("Run Report")}
        </Button>
      </Group>
      <div style={{ marginTop: 16 }}>
        <SubledgerReconciliationView reports={reports} />
      </div>
    </div>
  );
};

export default ReportSubledgerReconciliation;
